import React, { useState } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "../components/DataTable";
const productsList = [
    { name: "Gold Ring", rate: 5500 },
    { name: "Silver Chain", rate: 70 },
    { name: "Diamond Earrings", rate: 25000 }
];
export default function POS() {
    const [invoices, setInvoices] = useState([
        {
            invoiceId: "INV001",
            date: "2026-03-06",
            customerName: "John Doe",
            customerMobile: "9876543210",
            products: [
                { name: "Gold Ring", quantity: 2, weight: 10, making: 5, total: 115500 }
            ],
            totalAmount: 115500
        }
    ]);
    const [open, setOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [previewIndex, setPreviewIndex] = useState(null); // Preview modal index
    const [form, setForm] = useState({
        invoiceId: "",
        date: new Date().toISOString().split("T")[0],
        customerName: "",
        customerMobile: "",
        products: [],
        totalAmount: 0
    });
    const openCreate = () => {
        setForm({
            invoiceId: `INV${(invoices.length + 1).toString().padStart(3, "0")}`,
            date: new Date().toISOString().split("T")[0],
            customerName: "",
            customerMobile: "",
            products: [],
            totalAmount: 0
        });
        setEditIndex(null);
        setOpen(true);
    };
    const openEdit = (index) => {
        setForm(invoices[index]);
        setEditIndex(index);
        setOpen(true);
    };
    const openPreview = (index) => {
        setPreviewIndex(index);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };
    const addProductRow = () => {
        setForm({ ...form, products: [...form.products, { name: "", quantity: 1, weight: 0, making: 0, total: 0 }] });
    };
    const handleProductChange = (i, field, value) => {
        const updated = [...form.products];
        updated[i][field] = field === "quantity" || field === "weight" || field === "making" ? Number(value) : value;
        const productRate = productsList.find(p => p.name === updated[i].name)?.rate || 0;
        updated[i].total = (productRate * updated[i].weight) + ((updated[i].making / 100) * productRate * updated[i].weight) * updated[i].quantity;
        setForm({ ...form, products: updated });
        const totalAmount = updated.reduce((sum, p) => sum + p.total, 0);
        setForm(prev => ({ ...prev, totalAmount }));
    };
    const removeProductRow = (i) => {
        const updated = [...form.products];
        updated.splice(i, 1);
        const totalAmount = updated.reduce((sum, p) => sum + p.total, 0);
        setForm({ ...form, products: updated, totalAmount });
    };
    const saveInvoice = () => {
        if (!form.customerName || !form.products.length) {
            alert("Please fill required fields and add at least one product");
            return;
        }
        if (editIndex !== null) {
            const updated = [...invoices];
            updated[editIndex] = form;
            setInvoices(updated);
        } else {
            setInvoices([...invoices, form]);
        }
        setOpen(false);
    };
    const columns = ["S.No", "Invoice ID", "Date", "Customer", "Mobile", "Products", "Total Amount", "Action"];
    const rows = invoices.map((inv, i) => [
        i + 1,
        inv.invoiceId,
        inv.date,
        inv.customerName,
        inv.customerMobile,
        <Box>
            {inv.products.map((p, idx) => (
                <div key={idx}>{p.name} - Qty: {p.quantity}, Wt: {p.weight}g</div>
            ))}
        </Box>,
        `₹${inv.totalAmount.toLocaleString()}`,
        <Box>
            <Tooltip title="Preview">
                <IconButton color="info" onClick={() => openPreview(i)}><VisibilityIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Edit">
                <IconButton color="primary" onClick={() => openEdit(i)}><EditIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Delete">
                <IconButton color="error" onClick={() => {
                    const updated = invoices.filter((_, index) => index !== i);
                    setInvoices(updated);
                }}><DeleteIcon /></IconButton>
            </Tooltip>
        </Box>
    ]);
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>POS</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openCreate}>Create Invoice</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box sx={{ position: "fixed", top: 50, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: " 100%", maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editIndex !== null ? "Edit Invoice" : "Create Invoice"}</Typography>
                        <TextField label="Invoice ID" name="invoiceId" fullWidth value={form.invoiceId} disabled sx={{ mb: 2 }} />
                        <TextField label="Date" type="date" name="date" fullWidth value={form.date} onChange={handleChange} sx={{ mb: 2 }} InputLabelProps={{ shrink: true }} />
                        <TextField label="Customer Name" name="customerName" fullWidth value={form.customerName} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Customer Mobile" name="customerMobile" fullWidth value={form.customerMobile} onChange={handleChange} sx={{ mb: 2 }} />
                        <Typography variant="subtitle1" sx={{ mt: 2 }}>Products</Typography>
                        {form.products.map((p, i) => (
                            <Box key={i} sx={{ display: "flex", gap: 1, mb: 1 }}>
                                <TextField select label="Product" fullWidth value={p.name} onChange={(e) => handleProductChange(i, "name", e.target.value)}>
                                    {productsList.map(prod => (<MenuItem key={prod.name} value={prod.name}>{prod.name}</MenuItem>))}
                                </TextField>
                                <TextField label="Qty" type="number" sx={{ width: 100 }} value={p.quantity} onChange={(e) => handleProductChange(i, "quantity", e.target.value)} />
                                <TextField label="Weight (g)" type="number" sx={{ width: 120 }} value={p.weight} onChange={(e) => handleProductChange(i, "weight", e.target.value)} />
                                <TextField label="Making (%)" type="number" sx={{ width: 120 }} value={p.making} onChange={(e) => handleProductChange(i, "making", e.target.value)} />
                                <TextField label="Total" value={`₹${p.total.toLocaleString()}`} disabled sx={{ width: 150 }} />
                                <Button color="error" onClick={() => removeProductRow(i)}>Remove</Button>
                            </Box>
                        ))}
                        <Button variant="outlined" onClick={addProductRow} sx={{ mt: 1 }}>Add Product</Button>
                        <Typography variant="h6" sx={{ mt: 2 }}>Total Amount: ₹{form.totalAmount.toLocaleString()}</Typography>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={saveInvoice}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {previewIndex !== null && (
                <Box sx={{ position: "fixed", top: 50, left: 0, width: "150%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1200, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>Invoice Preview</Typography>
                        {previewIndex !== null && (() => {
                            const inv = invoices[previewIndex];
                            return (
                                <Box>
                                    <Typography><strong>Invoice ID:</strong> {inv.invoiceId}</Typography>
                                    <Typography><strong>Date:</strong> {inv.date}</Typography>
                                    <Typography><strong>Customer:</strong> {inv.customerName}</Typography>
                                    <Typography><strong>Mobile:</strong> {inv.customerMobile}</Typography>
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="subtitle1">Products:</Typography>
                                        {inv.products.map((p, i) => (
                                            <Box key={i} sx={{ display: "flex", gap: 2 }}>
                                                <Typography>{p.name}</Typography>
                                                <Typography>Qty: {p.quantity}</Typography>
                                                <Typography>Wt: {p.weight}g</Typography>
                                                <Typography>Making: {p.making}%</Typography>
                                                <Typography>Total: ₹{p.total.toLocaleString()}</Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                    <Typography variant="h6" sx={{ mt: 2 }}>Total Amount: ₹{inv.totalAmount.toLocaleString()}</Typography>
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                                        <Button variant="contained" onClick={() => setPreviewIndex(null)}>Close</Button>
                                    </Box>
                                </Box>
                            );
                        })()}
                    </Box>
                </Box>
            )}
        </Box>
    );
}